"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.someOrdersHaveSameLeadPassenger = someOrdersHaveSameLeadPassenger;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function someOrdersHaveSameLeadPassenger(orders) {
    const uniqueCustomers = new Set(orders.map(getLeadCustomerHash));
    return uniqueCustomers.size < orders.length;
}
function getLeadCustomerHash(order) {
    const lead = order.passengers.find((passenger) => passenger.type === legacy_enums_1.PassengerType.Lead);
    if (!lead || !lead.firstName || !lead.lastName) {
        return JSON.stringify(lead ?? Math.random());
    }
    return (lead.firstName + lead.lastName).toLowerCase();
}
//# sourceMappingURL=someOrdersHaveSameLeadPassenger.js.map